<template>
  <header>
    <nav class="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
      <div class="flex lg:flex-1 h-16 md:h-20 ">
        <a href="/" class="-m-1.5 p-1.5">
          <span class="sr-only">{{ siteConfig.title }}</span>
          <img  v-if="deskLogo" class="h-16 md:h-20 sm:w-[250px] w-[200px]" src="/_resources/themes/tepunuiotoka/images/tepunuiotoka.svg" alt="Tepunuiotoka" />
        </a>
      </div>
      <div class="flex lg:hidden">
        <button type="button" class="menu-btn -m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white-700" @click="mobileMenuOpen = true">
          <span class="text-sm">Menu</span>
          <Bars3Icon class="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      <PopoverGroup class="hidden lg:flex lg:justify-end lg:gap-x-8 items-baseline">
        <template v-for="(menuItem, index) in menuItems" :key="index">
          <Popover v-if="menuItem.Children.length" class="relative">
            <PopoverButton class="focus:outline-none flex items-center gap-x-1 text-sm font-medium leading-6 text-white">
              <div>
                {{ menuItem.Title }}<br>
                 <span class="text-sm font-light" v-if="menuItem.SecondaryMenuTitle">{{ menuItem.SecondaryMenuTitle }}</span>
              </div>
              <ChevronDownIcon class="h-5 w-5 flex-none text-white-400 mb-8" aria-hidden="true" />
            </PopoverButton>
            <transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-1" enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1">
              <PopoverPanel class="absolute -left-16 top-full z-10 mt-3 w-screen max-w-xs overflow-hidden rounded-3xl bg-black  shadow-lg ring-1 ring-white-900/5">
                <div class="p-4">
                  <div class="group relative flex items-center gap-x-6 rounded-lg p-2 text-sm  ">
                    <div class="flex-auto">
                      <a :href="menuItem.Link" class="block font-medium text-white">
                        {{ menuItem.Title }}
                        <span class="absolute inset-0" />
                      </a>
                      <p class="mt-1 text-white-600" v-if="menuItem.Description">{{ menuItem.Description }}</p>
                    </div>
                  </div>
                  <div v-for="child in menuItem.Children" :key="child.Title" class="group relative flex items-center gap-x-6 ml-4 rounded-lg p-2  text-sm  ">
                    <div class="flex-auto">
                      <a :href="child.Link" class="block text-white">
                        {{ child.Title }}
                        <span class="absolute inset-0" />
                      </a>
                       <p class="mt-1 text-white-600" v-if="child.Description">{{ child.Description }}</p>
                    </div>
                  </div>
                </div>
              </PopoverPanel>
            </transition>
          </Popover>
          <a v-else :href="menuItem.Link" class="text-sm font-medium leading-6 text-white uppercase">
            <span>{{ menuItem.Title }}</span><br>
            <span class="text-sm font-light" v-if="menuItem.SecondaryMenuTitle">{{ menuItem.SecondaryMenuTitle }}</span>
          </a>
        </template>
       
        <!-- Call to action desktop -->
        <div v-if="callToAction.url && callToAction.title" class="hidden lg:flex lg:flex-1 lg:justify-end">
          <a :href="callToAction.url" 
            :target="callToAction.openInNew ? '_blank' : '_self'"
            class="register-button uppercase animate-pulse">
            {{ callToAction.title }}
          </a>
        </div>
        <!-- Call to action desktop end -->

      </PopoverGroup>
      
    </nav>

    <Dialog class="lg:hidden" @close="mobileMenuOpen = false" :open="mobileMenuOpen">
      <div class="fixed inset-0 z-10" />
      <DialogPanel class="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-black px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-white-900/10">
        <div class="flex items-center justify-between">
          <a href="#" class="-m-1.5 p-1.5">
            <span class="sr-only">{{ siteConfig.title }}</span>
            <img class="h-16 sm:w-[300px] w-[200px] " src="/_resources/themes/tepunuiotoka/images/tepunuiotoka.svg" alt="tepunuiotoka" />
          </a>
          <button type="button" class="-m-2.5 rounded-md p-2.5 menu-btn" @click="mobileMenuOpen = false">
            <span class="sr-only">Close menu</span>
            <XMarkIcon class="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div class="mt-6 flow-root">
          <div class="-my-6 divide-y divide-white-500/10 pt-6">
            <div class="space-y-2">
              <Disclosure v-for="(menuItem, index) in menuItems" :key="index" as="div" class="-mx-3" v-slot="{ open }">
                <template v-if="menuItem.Children.length">
                  <DisclosureButton class="flex w-full items-center justify-between rounded-lg pt-2 pb-6 pl-3 pr-3.5 text-base font-semibold leading-7 text-white ">
                    <div class="text-left">
                      {{ menuItem.Title }}<br>
                      <span class="text-sm font-light">{{ menuItem.SecondaryMenuTitle }}</span>
                    </div>
                    <ChevronDownIcon :class="[open ? 'rotate-180' : '', 'h-5 w-5 flex-none']" aria-hidden="true" />
                  </DisclosureButton>
                  <DisclosurePanel class="mt-2 space-y-2">
                    <a :href="menuItem.Link" class="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-white ">
                      {{ menuItem.Title }}
                    </a>
                    <DisclosureButton v-for="child in menuItem.Children" :key="child.Title" as="a" :href="child.Link" class="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-white ">
                      {{ child.Title }}
                    </DisclosureButton>
                  </DisclosurePanel>
                </template>
                <a v-else :href="menuItem.Link" class="block rounded-lg px-3 py-2 text-base font-medium leading-7 text-white uppercase">
                  {{ menuItem.Title }}<br>
                  <span class="text-sm font-light">{{ menuItem.SecondaryMenuTitle }}</span>
                </a>
              </Disclosure>
            </div>

            <!-- Call to action mobile -->
            <div v-if="callToAction.url && callToAction.title" class="py-6 border-transparent">
              <a :href="callToAction.url" 
                :target="callToAction.openInNew ? '_blank' : '_self'"
                class="register-button uppercase animate-pulse">
                {{ callToAction.title }}
              </a>
            </div>
            <!-- Call to action mobile end -->

          </div>
        </div>
      </DialogPanel>
    </Dialog>
  </header>
</template>


<script setup>
import { ref, defineProps } from 'vue'
import {
  Dialog,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from '@headlessui/vue'
import {
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/vue/24/outline'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'

const props = defineProps({
  siteConfig: {
    type: Object,
    required: true
  },
  menuItems: {
    type: Array,
    required: true
  },
  deskLogo: {
    type: Boolean,
    required: true
  },
  callToAction: {
    type: Object,
    default: () => ({
      title: '',
      url: '',
      openInNew: false
    })
  }
  

})
// console.log('siteConfig', siteConfig);


const mobileMenuOpen = ref(false)
</script>
